/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import Auth from "~components/Templates/Auth";
import { LoginForm } from "~components/Organisms";
import { useAuth } from "~contexts/Auth";
import { useNavigate } from "react-router-dom";
import { ROLES } from "~routes/constants";

const Login = () => {
  const navigate = useNavigate();
  const { signed, user } = useAuth();

  useEffect(() => {
    if (signed) {
      if (user?.role === ROLES.admin) navigate("/home");
      else navigate("/chat");
    }
  }, [signed, user]);

  return (
    <Auth>
      <LoginForm />
    </Auth>
  );
};

export default Login;
